<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Smart Attendance | HR Management System</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Smart Attendance Management System" name="description" />
      <meta content="HR Team" name="author" />

      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- Custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- start page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Smart Attendance System</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                      <li class="breadcrumb-item">Leave & Attendance</li>
                      <li class="breadcrumb-item active">Smart Attendance</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <!-- end page title -->

            <!-- Dashboard Cards -->
            <div class="row">
              <!-- Today's Overview -->
              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Present Today</p>
                        <h5 class="mb-0 text-success">{{dashboardMetrics.todayMetrics?.present_count || 0}}</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                          <i class="mdi mdi-account-check"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Late Arrivals -->
              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Late Arrivals</p>
                        <h5 class="mb-0 text-warning">{{dashboardMetrics.todayMetrics?.late_count || 0}}</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                          <i class="mdi mdi-clock-alert"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Overtime -->
              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Overtime Today</p>
                        <h5 class="mb-0 text-primary">{{dashboardMetrics.todayMetrics?.overtime_count || 0}}</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                          <i class="mdi mdi-clock-plus"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Average Hours -->
              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Avg Working Hours</p>
                        <h5 class="mb-0 text-info">{{formatHours(dashboardMetrics.todayMetrics?.avg_working_hours) || '0.00'}}</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                          <i class="mdi mdi-chart-timeline"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Analytics Cards -->
            <div class="row" v-if="analytics">
              <!-- Frequent Late Comers -->
              <div class="col-lg-6">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">Frequent Late Comers</h4>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th>Employee</th>
                          <th>Late Days</th>
                          <th>Avg Minutes</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(emp, index) in analytics.frequentLateComers" :key="index">
                          <td>{{emp.employee_name}}</td>
                          <td><span class="badge bg-warning">{{emp.late_days}}</span></td>
                          <td>{{Math.round(emp.avg_late_minutes)}} min</td>
                        </tr>
                        <tr v-if="!analytics.frequentLateComers?.length">
                          <td colspan="3" class="text-center text-muted">No late arrivals in selected period</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Overtime Champions -->
              <div class="col-lg-6">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">Overtime Champions</h4>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th>Employee</th>
                          <th>Total OT Hours</th>
                          <th>OT Days</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(emp, index) in analytics.overtimeChampions" :key="index">
                          <td>{{emp.employee_name}}</td>
                          <td><span class="badge bg-primary">{{formatHours(emp.total_overtime)}}</span></td>
                          <td>{{emp.overtime_days}}</td>
                        </tr>
                        <tr v-if="!analytics.overtimeChampions?.length">
                          <td colspan="3" class="text-center text-muted">No overtime recorded in selected period</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Attendance Table -->
            <div class="row">
              <div class="col-12">
                <div class="card">

                  <!-- Filters -->
                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <div class="flex-grow-1">
                        <div class="search-box mb-0 me-3">
                          <div class="position-relative">
                            <input v-model="search" type="text" class="form-control bg-light border-light rounded"
                                   placeholder="Search employee..." spellcheck="false" data-ms-editor="true">
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex">
                        <div class="d-flex align-items-center me-3 pe-3">
                          <div>
                            <div class="float-end d-flex">
                              <!-- Department Filter -->
                              <div class="input-group fw-semibold text-uppercase me-3">
                                <label class="input-group-text text-uppercase">Department</label>
                                <select class="form-select" style="width: 200px;" v-model="departmentName">
                                  <option value="">All Departments</option>
                                  <option v-for="(item, index) in departments" :value="item.departmentName" :key="index">
                                    {{ item.departmentName }}
                                  </option>
                                </select>
                              </div>

                              <!-- Status Filter -->
                              <div class="input-group fw-semibold text-uppercase me-3">
                                <label class="input-group-text text-uppercase">Status</label>
                                <select class="form-select" style="width: 150px;" v-model="statusFilter">
                                  <option value="">All Status</option>
                                  <option value="Present">Present</option>
                                  <option value="Late">Late</option>
                                  <option value="Early_Departure">Early Departure</option>
                                  <option value="Overtime">Overtime</option>
                                  <option value="Absent">Absent</option>
                                  <option value="Partial">Partial</option>
                                </select>
                              </div>

                              <!-- Date Filters -->
                              <div class="input-group fw-semibold text-uppercase me-2">
                                <label class="input-group-text text-uppercase">FROM:</label>
                                <input v-model="startDate" class="form-control form-control-sm" type="date" id="from-date">
                              </div>

                              <div class="input-group fw-semibold text-uppercase">
                                <label class="input-group-text text-uppercase">TO:</label>
                                <input v-model="endDate" class="form-control form-control-sm" type="date" id="to-date">
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Action Buttons -->
                        <button @click="downloadAttendanceReport()" type="button"
                                class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                          <i class="bx bxs-download font-size-16"></i>
                          <span class="pl-1 d-md-inline">{{downloadText}}</span>
                        </button>

                        <!-- Process Data Button with Date Selector -->
                        <div class="dropdown me-2">
                          <button class="btn btn-success dropdown-toggle text-capitalize" type="button"
                                  id="processDataDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bx bx-refresh font-size-16"></i>
                            <span class="pl-1 d-md-inline">{{processText}}</span>
                          </button>
                          <div class="dropdown-menu dropdown-menu-end p-3" style="min-width: 280px;">
                            <h6 class="dropdown-header">Select Date to Process</h6>
                            <div class="mb-3">
                              <label for="processDate" class="form-label">Date:</label>
                              <input v-model="processDate" type="date" class="form-control" id="processDate">
                            </div>
                            <div class="d-grid">
                              <button @click="processAttendanceData()" type="button" class="btn btn-success">
                                <i class="bx bx-refresh me-1"></i>
                                Process Selected Date
                              </button>
                            </div>
                            <hr>
                            <div class="d-grid">
                              <button @click="processAttendanceDataToday()" type="button" class="btn btn-outline-success">
                                <i class="bx bx-calendar-today me-1"></i>
                                Process Today Only
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Attendance Table -->
                  <div class="card-body">
                    <div v-if="loading" class="text-center p-4">
                      <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                      <p class="mt-2">Loading attendance data...</p>
                    </div>

                    <div v-if="processing" class="alert alert-info">
                      <div class="d-flex align-items-center">
                        <div class="spinner-border spinner-border-sm text-info me-2" role="status"></div>
                        <span>Processing attendance data for {{processDate}}...</span>
                      </div>
                    </div>

                    <div v-else class="table-responsive">
                      <table class="table align-middle table-hover table-striped text-nowrap">
                        <thead class="table-dark">
                        <tr>
                          <th scope="col">Employee</th>
                          <th scope="col">Date</th>
                          <th scope="col">Shift</th>
                          <th scope="col">In/Out</th>
                          <th scope="col">Hours</th>
                          <th scope="col">Status</th>
                          <th scope="col">Breaks</th>
                          <th scope="col">Location</th>
                          <th scope="col">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in attendance" :key="index">
                          <td>
                            <div>
                              <strong>{{item.employee_name}}</strong><br>
                              <small class="text-muted">{{item.employee_id}}</small><br>
                              <small class="text-muted">{{item.departmentName || 'N/A'}}</small>
                            </div>
                          </td>
                          <td>{{formatDate(item.date)}}</td>
                          <td>
                            <div v-if="item.shift_start">
                              <small class="text-muted">{{item.shift_start}} - {{item.shift_end}}</small><br>
                              <small class="badge bg-light text-dark">{{item.shift_name || 'Regular'}}</small>
                            </div>
                            <div v-else>
                              <small class="text-muted">No shift assigned</small>
                            </div>
                          </td>
                          <td>
                            <div>
                              <strong class="text-success">In:</strong> {{item.first_in || 'N/A'}}<br>
                              <strong class="text-danger">Out:</strong> {{item.last_out || 'N/A'}}
                            </div>
                          </td>
                          <td>
                            <div>
                              <strong>{{item.total_hours}}h</strong><br>
                              <small class="text-muted" v-if="parseFloat(item.overtime_hours) > 0">
                                OT: {{item.overtime_hours}}h
                              </small>
                              <small class="text-muted" v-if="parseFloat(item.break_hours) > 0">
                                Break: {{item.break_hours}}h
                              </small>
                            </div>
                          </td>
                          <td>
                                <span class="badge" :class="`bg-${item.status_color}`">
                                  {{formatStatus(item.status)}}
                                </span>
                            <div v-if="item.late_minutes > 0" class="mt-1">
                              <small class="text-warning">Late: {{item.late_minutes}}min</small>
                            </div>
                          </td>
                          <td>
                            <div>
                              <span class="badge bg-secondary">{{item.total_entries}}/{{item.total_exits}}</span>
                              <div v-if="item.longest_break > 0" class="mt-1">
                                <small class="text-muted">Longest: {{item.longest_break_formatted}}</small>
                              </div>
                            </div>
                          </td>
                          <td>{{item.location || 'N/A'}}</td>
                          <td>
                            <button @click="viewEmployeeBreaks(item.employee_id, item.date)"
                                    class="btn btn-sm btn-outline-primary me-1" title="View Breaks">
                              <i class="bx bx-time-five"></i>
                            </button>
                            <button @click="viewRawTimesheet(item.employee_id, item.date)"
                                    class="btn btn-sm btn-outline-info" title="Raw Data">
                              <i class="bx bx-data"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <!-- No Data Message -->
                      <div v-if="!attendance.length && !loading" class="text-center p-4">
                        <i class="bx bx-calendar-x font-size-48 text-muted"></i>
                        <p class="mt-2 text-muted">No attendance records found for the selected criteria</p>
                      </div>
                    </div>

                    <!-- Pagination -->
                    <div class="row mt-3" v-if="totalPages > 1">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{((currentPage - 1) * pageSize) + 1}} to {{Math.min(currentPage * pageSize, totalCount)}} of {{totalCount}} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers">
                          <ul class="pagination">
                            <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 1 }">
                              <a href="#" @click.prevent="prevPage()" class="page-link">Previous</a>
                            </li>
                            <li v-for="page in visiblePages" :key="page"
                                class="paginate_button page-item" :class="{ active: currentPage === page }">
                              <a href="#" @click.prevent="goToPage(page)" class="page-link">{{page}}</a>
                            </li>
                            <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages }">
                              <a href="#" @click.prevent="nextPage()" class="page-link">Next</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">
                  {{new Date().getFullYear()}} Smart Attendance System
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->

    <!-- Employee Breaks Modal -->
    <div class="modal fade" id="breaksModal" tabindex="-1" aria-labelledby="breaksModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="breaksModalLabel">Employee Break Details</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                <tr>
                  <th>Date</th>
                  <th>Break Out</th>
                  <th>Break In</th>
                  <th>Duration</th>
                  <th>Location</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(brk, index) in employeeBreaks" :key="index">
                  <td>{{formatDate(brk.date)}}</td>
                  <td>{{brk.break_out}}</td>
                  <td>{{brk.break_in || 'Still Out'}}</td>
                  <td>{{brk.break_duration_formatted}}</td>
                  <td>{{brk.location_out}} → {{brk.location_in || 'N/A'}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Raw Timesheet Modal -->
    <div class="modal fade" id="rawTimesheetModal" tabindex="-1" aria-labelledby="rawTimesheetModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="rawTimesheetModalLabel">Raw Timesheet Data</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                <tr>
                  <th>Time</th>
                  <th>Employee</th>
                  <th>Direction</th>
                  <th>Device/Location</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(entry, index) in rawTimesheet" :key="index">
                  <td>{{entry.acct}}</td>
                  <td>{{entry.pname}}</td>
                  <td>
                        <span class="badge" :class="entry.direction === 'enter' ? 'bg-success' : 'bg-danger'">
                          {{entry.direction}}
                        </span>
                  </td>
                  <td>{{entry.dname}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right bar overlay-->
    <div class="rightbar-overlay"></div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import moment from "moment/moment";
import {
  authUrl,
  execute,
  executeDownload,
  getRight
} from "@/api";

export default {
  name: "SmartAttendance",
  components: { NavigationBar },
  data() {
    return {
      loading: false,
      processing: false,
      downloadText: 'Download Report',
      processText: 'Process Data',

      // Pagination
      currentPage: 1,
      totalPages: 0,
      pageSize: 25,
      totalCount: 0,

      // Filters - CHANGED: Both startDate and endDate default to today (0 days from today)
      search: "",
      departmentName: '',
      statusFilter: '',
      startDate: this.getDateString(0), // Changed from -7 to 0 (today)
      endDate: this.getDateString(0), // Already was today

      // Process Data specific date
      processDate: this.getDateString(0), // today by default

      // Data
      attendance: [],
      departments: [],
      dashboardMetrics: {},
      analytics: {},
      employeeBreaks: [],
      rawTimesheet: [],

      message: null,
      searchTimeout: null
    };
  },

  mounted() {
    this.initializeData();
  },

  computed: {
    visiblePages() {
      return this.pagination(this.currentPage, this.totalPages, 5);
    }
  },

  watch: {
    startDate(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.getSmartAttendance();
      }
    },
    endDate(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.getSmartAttendance();
      }
    },
    search(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.debounceSearch();
      }
    },
    departmentName(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.getSmartAttendance();
      }
    },
    statusFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
        this.getSmartAttendance();
      }
    }
  },

  methods: {
    async initializeData() {
      await Promise.all([
        this.getDepartments(),
        this.getDashboardMetrics(),
        this.getSmartAttendance()
      ]);
    },

    getDateString(daysFromToday) {
      const date = new Date();
      date.setDate(date.getDate() + daysFromToday);
      return date.toISOString().split('T')[0];
    },

    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getSmartAttendance();
      }, 500);
    },

    async getSmartAttendance() {
      this.loading = true;
      this.attendance = [];

      const data = new FormData();
      data.append("function", "getSmartAttendance");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("startDate", this.startDate);
      data.append("endDate", this.endDate);
      data.append("search", this.search);
      data.append("departmentName", this.departmentName);
      data.append("status", this.statusFilter);

      try {
        const res = await execute(data, authUrl);
        this.loading = false;

        if (res.data.success) {
          this.attendance = res.data.data.attendance;
          this.totalCount = res.data.data.totalCount;
          this.analytics = res.data.data.analytics;
          this.totalPages = Math.ceil(this.totalCount / this.pageSize);
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.loading = false;
        this.message = e.message;
      }
    },

    async getDepartments() {
      const data = new FormData();
      data.append("function", "getDepartments");

      try {
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.departments = res.data.data.departments;
        }
      } catch (e) {
        console.error('Error loading departments:', e);
      }
    },

    async getDashboardMetrics() {
      const data = new FormData();
      data.append("function", "getAttendanceDashboard");
      data.append("date", this.getDateString(0)); // today

      try {
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.dashboardMetrics = res.data.data;
        }
      } catch (e) {
        console.error('Error loading dashboard metrics:', e);
      }
    },

    async processAttendanceData() {
      if (!this.processDate) {
        this.showNotification('Please select a date to process', 'error');
        return;
      }

      this.processing = true;
      this.processText = 'Processing...';

      const data = new FormData();
      data.append("function", "processTimesheetData");
      data.append("date", this.processDate);

      try {
        const res = await execute(data, authUrl);
        this.processing = false;
        this.processText = 'Process Data';

        if (res.data.success) {
          this.showNotification(`Attendance data processed successfully for ${this.formatDate(this.processDate)}!`, 'success');

          // Close the dropdown
          const dropdown = bootstrap.Dropdown.getInstance(document.getElementById('processDataDropdown'));
          if (dropdown) {
            dropdown.hide();
          }

          // Refresh data if the processed date is within the current view range
          if (this.processDate >= this.startDate && this.processDate <= this.endDate) {
            await this.getSmartAttendance();
          }

          await this.getDashboardMetrics();
        } else {
          this.showNotification(res.data.message || 'Error processing attendance data', 'error');
        }
      } catch (e) {
        this.processing = false;
        this.processText = 'Process Data';
        this.showNotification('Error processing attendance data: ' + e.message, 'error');
        console.error('Processing error:', e);
      }
    },

    async processAttendanceDataToday() {
      this.processDate = this.getDateString(0); // Set to today
      await this.processAttendanceData();
    },

    async viewEmployeeBreaks(employeeId, date) {
      const data = new FormData();
      data.append("function", "getEmployeeBreaks");
      data.append("employee_id", employeeId);
      data.append("startDate", date);
      data.append("endDate", date);

      try {
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.employeeBreaks = res.data.data.breaks;
          const modal = new bootstrap.Modal(document.getElementById('breaksModal'));
          modal.show();
        }
      } catch (e) {
        this.showNotification('Error loading break details', 'error');
      }
    },

    async viewRawTimesheet(employeeId, date) {
      // Get raw timesheet data for the employee on that date
      const data = new FormData();
      data.append("function", "getRawTimesheet");
      data.append("employee_id", employeeId);
      data.append("date", date);

      try {
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.rawTimesheet = res.data.data.timesheet;
          const modal = new bootstrap.Modal(document.getElementById('rawTimesheetModal'));
          modal.show();
        }
      } catch (e) {
        this.showNotification('Error loading raw timesheet data', 'error');
      }
    },

    async downloadAttendanceReport() {
      this.downloadText = "Generating...";

      const data = new FormData();
      data.append("function", "downloadAttendanceReport");
      data.append("startDate", this.startDate);
      data.append("endDate", this.endDate);
      data.append("search", this.search);
      data.append("departmentName", this.departmentName);
      data.append("status", this.statusFilter);

      try {
        const response = await executeDownload(data, authUrl);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `smart_attendance_${this.startDate}_to_${this.endDate}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.downloadText = "Download Report";
      } catch (e) {
        this.downloadText = "Download Report";
        this.showNotification('Error downloading report', 'error');
      }
    },

    // Notification method that works with or without toast library
    showNotification(message, type = 'info') {
      // Try to use toast if available
      if (this.$toast) {
        if (type === 'success') {
          this.$toast.success(message);
        } else if (type === 'error') {
          this.$toast.error(message);
        } else {
          this.$toast.info(message);
        }
        return;
      }

      // Fallback to browser alert or console
      if (type === 'error') {
        console.error('Error:', message);
        alert('Error: ' + message);
      } else if (type === 'success') {
        console.log('Success:', message);
        // You could create a temporary success message div here
        this.showTemporaryMessage(message, 'success');
      } else {
        console.info('Info:', message);
        this.showTemporaryMessage(message, 'info');
      }
    },

    // Alternative notification method using Bootstrap alerts
    showTemporaryMessage(message, type = 'info') {
      // Create a temporary alert div
      const alertDiv = document.createElement('div');
      alertDiv.className = `alert alert-${type === 'success' ? 'success' : type === 'error' ? 'danger' : 'info'} alert-dismissible fade show position-fixed`;
      alertDiv.style.cssText = 'top: 20px; right: 20px; z-index: 9999; min-width: 300px;';
      alertDiv.innerHTML = `
        ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
      `;

      document.body.appendChild(alertDiv);

      // Auto remove after 5 seconds
      setTimeout(() => {
        if (alertDiv.parentNode) {
          alertDiv.parentNode.removeChild(alertDiv);
        }
      }, 5000);
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }

      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getSmartAttendance();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getSmartAttendance();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getSmartAttendance();
      }
    },

    // Formatting methods
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },

    formatTime(time) {
      return moment(time, 'HH:mm:ss').format('HH:mm');
    },

    formatHours(hours) {
      return parseFloat(hours).toFixed(2);
    },

    formatStatus(status) {
      return status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num);
    },

    getRight(type) {
      return getRight(type);
    }
  }
};
</script>

<style scoped>
.mini-stats-wid {
  border: none;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  transition: transform 0.2s ease;
}

.mini-stats-wid:hover {
  transform: translateY(-2px);
}

.table-responsive {
  max-height: none;
}

.badge {
  font-size: 0.75em;
  padding: 0.5em 0.75em;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.search-box .search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #8492a6;
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}

.pagination .page-link {
  padding: 0.5rem 0.75rem;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0;
}

.text-muted {
  color: #6c757d !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.dropdown-header {
  font-weight: 600;
  color: #495057;
}

.alert {
  border-radius: 0.375rem;
}
</style>